export enum SoftwareRequestStatus {
	Approved = 'Approved',
	Rejected = 'Rejected',
	Waiting = 'Waiting',
	Completed = 'Completed',
	InProgress = 'In Progress',
}